/**
 * The floor materials an inspection saw, room by room, for the floor a
 * demolition takes up (`labor/demoScope.js` `floorTakenUp`; user ruling,
 * 2026-10-24: "use inspection if exists"). Read from the
 * `structures/{sid}/existingConditions` docs of kind `floor` — one per floor
 * the room has — by each doc's `roomId`. A doc with no material class (a
 * floor the recording never saw, `never-seen` / `occluded`) adds nothing, so
 * a room whose every floor went unseen is a room with no finding. Pure.
 *
 * @param {Array<{ id?: string, kind: string, roomId?: string,
 *   material?: { class?: string } }>} docs
 * @returns {Object<string, string[]>}  `{ [roomId]: [material class] }`, each
 *   room's classes once, in the docs' id order
 */
function floorFindings(docs = []) {
  const out = {};
  const floors = (docs || [])
    .filter((d) => d?.kind === 'floor' && d.roomId && d.material?.class)
    .sort((a, b) => String(a.id ?? '').localeCompare(String(b.id ?? '')));
  for (const d of floors) {
    const list = (out[d.roomId] ??= []);
    if (!list.includes(d.material.class)) list.push(d.material.class);
  }
  return out;
}

module.exports = { floorFindings };
